module.exports = __webpack_public_path__ + "static/media/volvo_novum.25cb6845.ttf";